import { render, staticRenderFns } from "./Iasi.vue?vue&type=template&id=d9867624&"
import script from "./Iasi.vue?vue&type=script&lang=js&"
export * from "./Iasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports